module.exports = __webpack_public_path__ + "media/images/top-arw-3bbf4019c74a8de0bb8d01d8f0b40a61.png";